import React from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import { actionCreators, ApplicationState, AppState } from "../store";
import { getIDBValue, isIosDevice, isMobileDevice } from "../utils";
import { Auth } from "aws-amplify";
import axios from 'axios';
import { useDispatch } from "react-redux";

// -------------
// Props
type PurePrivateRouteProps = { returnElement: React.ReactNode };
export type PrivateRouteProps = AppState & PurePrivateRouteProps;
export const PrivateRoute = (props: PrivateRouteProps) => {
    const [isMobile] = React.useState(isMobileDevice());
    const isAuthorize = (props.user && props.user.cognit_user.challengeName !== 'NEW_PASSWORD_REQUIRED') ? true : false;
    const isNewPasswordRequired = props.user && props.user.cognit_user.challengeName === 'NEW_PASSWORD_REQUIRED';
    const dispatch = useDispatch();
    
    const initPageSize = async () => {
        Auth.currentSession().then(async (session) => {
            const url = process.env.REACT_APP_APIGW_URL + "/master/settings/get";
            const token = session.getIdToken().getJwtToken();
            const data = await axios.get(url,{
                headers: {
                    'Authorization': token,
                }
            })
            if(data && data.status == 200){
                dispatch({type:"SET_INIT_PAGE_SIZE",payload:{data:data.data.init_page_size}});
            }
        }).catch((err) => {
        });
    };

    React.useEffect(() => {
        if(isAuthorize){
            if(!props.initialPageSize){
                const fetchInitPageSize = async () => {
                    await initPageSize();
                };
                fetchInitPageSize();
            }
        }
    }, [isAuthorize]);

    if (isAuthorize) {
        return <>{props.returnElement}</>
    }
    else if (isNewPasswordRequired) {
        return <Navigate to={"/changepass"} replace={true} />
    } 
    else if (isMobile) {
        const isIOS = isIosDevice();
        const pathAndQuery = encodeURIComponent(window.location.pathname + window.location.search);
        if (isIOS) {
            getIDBValue().then((lastPath) => {
                if(!lastPath){
                    return <Navigate to={"/login?redirect=/solarLiveStatus"} replace={true} />
                }
            });
        }
        return <Navigate to={`/login?redirect=${pathAndQuery}`} replace={true} />
    }
    return (
        <Navigate to={"/login"} replace={true} />
    );
};

export default connect((state: ApplicationState) => state.app)(PrivateRoute);